import Conversation from 'types/Conversation';

export const getConversationName = (c: Conversation, userId: number) =>
  c.users
    .reduce<string[]>(
      (acc, u) =>
        u.id === userId ? acc : [...acc, `${u.firstName} ${u.lastName}`],
      [],
    )
    .join(', ');
